/**
 * 选做题 model
 * */
import { BaseSubject } from '../BaseSubject.model';
import store from '@/store/index';
import { PAGE_SIZE_CELL } from '@/subjects/constant';
const ANSWER_HEIGHT_AND_TH = 340; //解答题默认高度
const ANSWER_HEIGHTH = 300; //解答题默认高度
let answerPanelState = store.state.answerPanel;
const MARGIN_BOTTOM = 10; // 每个页面底部空白的高度值为10px
const TH_HEIGHT = 40; //标题高度
// const TAG_P_HEIGHT = 38; // 一个p元素的固定高度
// const TAG_P_HEIGHT = 54; // 一个p元素的固定高度
import { TAG_P_HEIGHT } from '@/subjects/constant';
import { PADDING_TOP } from '../constant';

export class ChooseModel extends BaseSubject {
  /**
   * dCount, nCount 表示几选几中的 分母与分子
   * */

  // selCount?: any

  /**
   * htmlArray 存储html片段
   * */

  // htmlArray?: any

  /**
   * items 添加弹窗列数据
   * */

  // items: { start?: any, end?: any, score?: any, value: any }[] = []

  constructor(obj) {
    super(obj);
    obj = obj || {};
    this.type = obj.type || 6; // 选做题类型
    this.value = obj.value; // 选做题数量
    this.name = obj.name || '选做题';
    this.score = obj.score;
    if (obj.items && obj.items.length) {
      this.items = [];
      this.items.push({
        no: 1,
        score: obj.score,
        value: obj.score, // 保留字段
      });
      this.items = obj.items;
      const hash = {};
      this.items = this.items.reduce((item, next) => {
        hash[next.no] ? '' : (hash[next.no] = true && item.push(next));
        return item;
      }, []); // 对象数组去重
    } else {
      this.items.push({
        no: 1,
        score: obj.score,
        value: obj.score, // 保留字段
      });
    }
  }

  // addItem() {
  //   this.items.push({
  //     start: this.start,
  //     end: this.end,
  //     score: this.score,
  //     value: this.value, // 选题数量
  //   });
  // }

  render(options = {}) {
    const { hurdleReset } = options; // 不是通过二栏三栏render的
    const items = this.items;
    const htmlArray = [];
    for (let index = 0; index < items.length; index++) {
      const item = items[index];
      const thList = [];
      for (let idx = Number(this.start); idx <= Number(this.end); idx++) {
        thList.push(idx);
      }
      item['thList'] = thList;
      // item['innerHTML'] = `<p class='row'>${item.start} ~ ${item.end}.(${item.score}分)</p>`;
      item['innerHTML'] = `<p class='row'>​&#8203;</p>`;
      htmlArray.push({ ...item });
    }
    this.items = items;
    if (!hurdleReset && this.htmlArray.length && !this.fromEdit) {
    } else {
      this.htmlArray = htmlArray;
    }
    console.log(this.htmlArray);
    this.computedScoreAndTH(); // 渲染之前计算题号和分数
  }
  computedScoreAndTH(unComputedTH) {
    this.totalScore = this.score;
    if (unComputedTH) {
      return;
    }
    // this.end = '';
  }
  deleteItem(index) {
    this.items.splice(index, 1);
    this.computedScoreAndTH(true);
  }
  appendToPage(state, pageHeight, newTopicHeight) {
    console.log("ChooseModel appendToPage::::::", state);
    state.answerTopicAdded = []; //将之前新增的解答题清空
    state.answerSignal = true;
    this.htmlArray.forEach((html, index) => {
      // state.pageCell[state.pageCell.length - 1].items.push(this.);
      state.answerTopicAdded.push({
        ...html,
        name: this.name,
        totalScore: this.totalScore,
        end: this.end,
        th: this.th,
        type: this.type,
        thList: html.thList,
        hasTitle: true,
        type: this.type,
        isHurdle: false,
        initDragHeight: html.initDragHeight || ANSWER_HEIGHTH,
        // 初始化拖拽高度（如果是弹窗生成的题目高度是由数据生产者计算编辑器空格生成的高度，不需要initDragHeight，如果是拖拽生成的高度就是这个属性）
        innerHTML: html.innerHTML,
      });
    });
    let currentPage = state.pageCell.length - 1;
    if (this.page.isSurplusPage(state, currentPage, TH_HEIGHT + TAG_P_HEIGHT)) {
      state.newTopicHeight = this.items.length * ANSWER_HEIGHTH + TH_HEIGHT; // 算上标题的总高度
      let cloneTopicList = JSON.parse(
        JSON.stringify(state.pageCell[state.pageCell.length - 1].fillTopiclist)
      );
      cloneTopicList = [...cloneTopicList, ...state.answerTopicAdded];
      // state.pageCell[state.pageCell.length - 1].fillTopiclist = [
      //   ...state.pageCell[state.pageCell.length - 1].fillTopiclist,
      //   ...state.answerTopicAdded,
      // ];
      this.currentPage = state.pageCell.length - 1;
      this.recursionCutAnswerPage(state, currentPage, state.existHeight, undefined, false);
    } else {
      this.page.createNextPage(state.pageCell);
      currentPage++;
      state.newTopicHeight = this.items.length * ANSWER_HEIGHTH + TH_HEIGHT; // 算上标题的总高度
      // state.pageCell[currentPage].fillTopiclist = [
      //   ...state.pageCell[currentPage].fillTopiclist,
      //   ...state.answerTopicAdded,
      // ];
      this.currentPage = state.pageCell.length - 1;
      this.recursionCutAnswerPage(state, currentPage, 0, undefined, false);
    }
    // throw new Error('Method not implemented.');
  }

  /**
   * 解答题递归更新纸张高度
   */
  recursionCutAnswerPage(state, currentPage, existHeight, currentTopicStackList, isSellCall) {
    // 这里可以将数据遍历好之后一次性赋值给store 然后更新视图
    // currentTopicStackList =
    //   currentTopicStackList ||
    //   this.currentTopicStackList.filter(topic => {
    //     return topic.type === 3;
    //   });
    currentTopicStackList = JSON.parse(
      JSON.stringify(currentTopicStackList || state.answerTopicAdded)
    );
    let { acCardYJType } = answerPanelState.answerSheet;
    let cardGapHeight = acCardYJType == 2 ? 34 : 0
    existHeight = existHeight + cardGapHeight;

    // currentTopicStackList = JSON.parse(JSON.stringify(currentTopicStackList));
    const currentMaxHeight = state.pageCell[currentPage].contentHeight;
    const canFillHeight = currentMaxHeight - existHeight; // 可填充高度
    let topicHeight = state.newTopicHeight + cardGapHeight;
    if (topicHeight > canFillHeight) {
      // 当有存在高度的时候 大于存在高度跨栏 topicHeight减去填充高度 超出高度insert下一页 循环
      let newFillTopicList = [];
      topicHeight -= isSellCall ? currentMaxHeight : canFillHeight; // 当上面没有已存在的高度可以直接减去currentMaxHeight
      state.newTopicHeight = topicHeight;
      // const yushuHeight = canFillHeight % ANSWER_HEIGHTH; //取余
      currentTopicStackList.forEach((item, index) => {
        state.pageCell[currentPage].fillTopiclist.push({
          th: this.th,
          ...item,
          isHurdle: true,
          initDragHeight: canFillHeight - TH_HEIGHT,
          innerHTML: currentTopicStackList[currentTopicStackList.length - 1].innerHTML,
        });
      });
      // const zhengshuHeight = Math.floor((canFillHeight - TH_HEIGHT) / ANSWER_HEIGHTH); //取整
      // newFillTopicList = currentTopicStackList.splice(
      //   // 如果当前的解答题已经生成了 后面还是新增的解答题的话
      //   // 这边filter筛选就要把之前的解答题去除掉再push
      //   zhengshuHeight + 1,
      //   currentTopicStackList.length - 1
      // );
      // this.removeSurplusStackWhenFirstInitCurtPage(state, currentPage); //当初第一是初始化list的时候移除超出的题型（就是对新增的题型重造）
      // currentTopicStackList.forEach((item, index) => {
      //   // 将当前元素重新push到state.page当中去
      //   if (yushuHeight > 0 && index == currentTopicStackList.length - 1) {
      //     // if (yushuHeight < TAG_P_HEIGHT + 20) {
      //     //   state.newTopicHeight =
      //     //     state.newTopicHeight + canFillHeight - zhengshuHeight * ANSWER_HEIGHTH + 10;
      //     // } else {
      //     state.pageCell[currentPage].fillTopiclist.push({
      //       th: this.th,
      //       ...item,
      //       isHurdle: true,
      //       initDragHeight: canFillHeight - TH_HEIGHT,
      //       innerHTML: currentTopicStackList[currentTopicStackList.length - 1].innerHTML,
      //     });
      //     // }
      //   } else {
      //     state.pageCell[currentPage].fillTopiclist.push(item);
      //   }
      // });
      this.page.createNextPage(state.pageCell);
      currentPage++;
      const lastStack = currentTopicStackList[currentTopicStackList.length - 1];
      this.page.insertNextPageHeadStack(
        state.pageCell[currentPage],
        topicHeight + PADDING_TOP,
        this.type,
        undefined,
        undefined,
        lastStack.no
      );
      // }
      // this.recursionCutAnswerPage(
      //   state,
      //   currentPage,
      //   ANSWER_HEIGHTH - yushuHeight + TH_HEIGHT,
      //   newFillTopicList,
      //   true
      // );
    } else {
      // const yushuHeight = topicHeight % ANSWER_HEIGHT_AND_TH; //取余
      // const zhengshuHeight = parseInt(canFillHeight / ANSWER_HEIGHT_AND_TH); //取整
      currentTopicStackList.forEach(item => {
        state.pageCell[currentPage].fillTopiclist.push(item);
      });

      // state.loadingInstance.close();
      return console.log('停止递归');
    }
  }

  removeSurplusStackWhenFirstInitCurtPage(state, page) {
    if (page == this.currentPage) {
      // this.currentPage用来区别递归增加的页码还是没有超过高度增加的
      state.pageCell[page].fillTopiclist = state.existStack;
    }
  }
}
